import ApiResourceManager from '../ApiResourceManager';

export default class PolygraphyManager extends ApiResourceManager {
  getProducts = () =>
    this.request({
      method: 'GET',
      url: '/polygraphy/products',
    });

  createProduct = (template, data) =>
    this.request({
      method: 'POST',
      url: `/polygraphy/products/${template}`,
      data,
    });

  updateProduct = (id, data) =>
    this.request({
      method: 'POST',
      url: `/polygraphy/products/${id}`,
      data,
    });

  getOrders = (page) =>
    this.request({
      method: 'GET',
      url: '/polygraphy/orders',
      params: { page },
    });

  createOrder = (data) =>
    this.request({
      method: 'POST',
      url: '/polygraphy/orders',
      data,
    });

  getAutoOrderSettings = () =>
    this.request({
      method: 'GET',
      url: '/polygraphy/auto-order-settings',
    });

  updateAutoFlyerOptOut = (data) =>
    this.request({
      method: 'PUT',
      url: '/polygraphy/auto-order-settings/opt-out',
      data,
    });

  updateApprovedDesign = (data) =>
    this.request({
      method: 'PUT',
      url: '/polygraphy/auto-order-settings/approved-design',
      data,
    });
}
